
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class BaseLayout extends Vue {
  protected name = "BaseLayout";
}
